import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map, shareReplay, switchMap } from 'rxjs/operators';

import { AdvancedSearchSandboxService } from '@mediahaven/shared';
import { ExtendedProfileField, User } from '@stylehaven/components';
import { uniqWith } from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class PublicAdvancedSearchSandboxService extends AdvancedSearchSandboxService {
    public getProfileFieldsStream(): Observable<ExtendedProfileField[]> {
        return this.userStoreService.getCurrentUser().pipe(
            map((user: User) => user.Organisation.Id),
            switchMap(orgId => this.profileService.getAdvancedSearchProfileFields(orgId)),
            map(fields => fields.filter(field => field.Public)),
            map(fields =>
                uniqWith(
                    fields,
                    (field1: ExtendedProfileField, field2: ExtendedProfileField) =>
                        field1.FieldDefinition.DottedKey === field2.FieldDefinition.DottedKey
                )
            ),
            shareReplay(1)
        );
    }
}
